import { ReactComponent as FlagIcon } from "./svg/hk-flag.svg";
import "../flag-icon.scss";

export const HKFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
